import TagManager from 'react-gtm-module';

export const useEmailTag = ({ email }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_email',
      category: 'UI Interaction',
      action: 'Click',
      label: 'Email',
      email
    }
  });
